import userManager from '@/auth/authService';
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react';

export const Route = createFileRoute('/callback')({
  component: RouteComponent,
})

function RouteComponent() {
  useEffect(() => {
    userManager.signinRedirectCallback().then(() => {
      window.location.replace('/'); // redirect to home or wherever
    }).catch((err) => {
      console.error('OIDC callback error:', err);
    });
  }, []);

  return <div>Processing login...</div>;
}


